const angular = require('angular');
const { controllers } = require('chart.js');
var app = angular.module('learn-controllers');
/**
 * Defines the admin badge view, create, and edit component
 * @argument {Application} Application injected to gain access to the global Application functions and properties
 * @argument {Badges} Badges injected to gain access to the Badges Resource
 * @argument {contentReference} contentReference injected to gain access to the contentReference factory
 */
app.controller('editBadge', ['Application', 'Authorization', 'AccessHelper', 'Badges', 'ContentReference', '$scope', '$translate', function (Application, Authorization, AccessHelper, Badges, ContentReference, $scope, $translate) {
  var self = this;

  self.features = Application.features.flags();
  self.allowance = {
      badges: self.features.badges && AccessHelper.isAllowed(['admin', 'badges'], null, ['admin'])
  };

  if (!self.allowance.badges || Application.access.role !== 'admin') {
      Application.navigation.goTo('/explore');
      return;
  }

  self.activeTab = 'criteria';
  self.loading = true;
  self.updated = {};
  self.creator = Authorization.getAuthToken().user;
  self.routeParams = Application.navigation.getRouteParameters();
  self.showSaveModal = false;
  self.selectedCriteriaIdList = [];
  self.omittedContentTypes = ['survey'];

  self.requestReturnHome = function() {
    if (!self.currentBadge._id) {
      self.showSaveModal = true
      return;
    }
    self.returnHome();
  };

  self.returnHome = function () {
    Application.navigation.goTo('/overview/badges');
  }

  const typeToPathType = {
    article: 'articles',
    video: 'videos',
    file: 'files',
    track: 'tracks',
    scorm: 'scorm',
    presentation: 'presentations',
    imported_content: 'imported-content'
  }

  self.edit = {
    inEdit: !self.routeParams.id,
    startEditing: function () {
      self.edit.inEdit = true;
    }
  }

  self.actions = {
    save: function (toUpdate = self.updated) {
      if (!self.currentBadge._id) {
        const missing = self.actions.checkRequired();
        if (missing && missing.length) {
          let errorMessage = 'The following fields are required: ';
          missing.forEach(function (item, index) {
            errorMessage += item;
            if (index === (missing.length - 1)) {
              errorMessage += '.';
              return;
            }
            errorMessage += ', ';
          });
          Application.messaging.addMessage({ type: 'error', duration: 6, text: errorMessage });
          throw Error(errorMessage);
        }

        Badges.create({}, self.currentBadge).$promise
          .then(data => {
            const successMessage = `${self.currentBadge.title} has been successfully created`;
            self.currentBadge._id = data.id;
            Application.messaging.addMessage({ type: 'success', duration: 6, text: successMessage });
            return;
          })
        return;
      }
      Badges.update({ subresource: self.currentBadge._id }, toUpdate).$promise
        .then(data => {
          self.edit.inEdit = false;
          self.updated = {};
          const successMessage = `${self.currentBadge.title} has been successfully updated`;
          Application.messaging.addMessage({ type: 'success', duration: 6, text: successMessage });
          return;
        })
    },
    addImage: function (link) {
      self.currentBadge.uploaded_image = link;
    },
    checkRequired: function () {
      var missing = [];
      if (!self.currentBadge.title.length) {
        missing.push('Badge Name');
      }
      if (!self.currentBadge.description.length) {
        missing.push('Description');
      }
      if (!self.currentBadge.uploaded_image.length) {
        missing.push('Image');
      }
      if (missing.length) {
        return missing;
      }
      return null;
    },
    checkForUpdates: function() {
      return Object.keys(self.updated).length;
    },
    goToContent: function (contentId, contentType) {
      const path = `/view/${typeToPathType[contentType]}/${contentId}`
      Application.navigation.goTo(path);
    },
    goToUser: function (userId) {
      const path = `/edit/users/${userId}`
      Application.navigation.goTo(path);
    },
    toggleBadge: function () {
      if (!self.currentBadge._id) {
        const errorMessage = 'Badge must be created and criteria must be added before badge can be enabled';
        Application.messaging.addMessage({ type: 'error', duration: 6, text: errorMessage });
        return;
      }
      if (!self.currentBadge.completable_entities.length) {
        const errorMessage = 'Criteria must be added before badge can be enabled';
        Application.messaging.addMessage({ type: 'error', duration: 6, text: errorMessage });
        return;
      }
      self.currentBadge.active = !self.currentBadge.active;
      Badges.update({ subresource: self.currentBadge._id }, { active: self.currentBadge.active }).$promise
    }
  }

  const searchContentToCriteria = function (content) {
    return content.map(item => {
      return {
        entity_type: item.type,
        entity_id: item._id,
        active: false,
        title: item.name,
        date_added: new Date(),
        added_by: {_id: Application.access.user._id, full_name: self.creator.full_name}, //existing criteria is an object so we return this as an object
      }
    })
  }

  const criteriaToCriteriaDTO = function (criteria) {
    return criteria.map(entity => {
      return {...entity, added_by: entity.added_by._id}
    })
  }

  self.criteria = {
    showCriteriaSearch: false,
    loading: false,
    activeEditId: '',
    showEditMenu: false,
    addCriteria: function (items) {
      const formattedAdditions = searchContentToCriteria(items);
      const newCompletableEntities = formattedAdditions.concat(self.currentBadge.completable_entities);
      const updateBody = criteriaToCriteriaDTO(newCompletableEntities);
      self.criteria.loading = true;
      Badges.update({ subresource: self.currentBadge._id }, { completable_entities: updateBody }).$promise
        .then(id => {
          const successMessage = `Your criteria has been successfully added`;
          Application.messaging.addMessage({ type: 'success', duration: 6, text: successMessage });
          self.currentBadge.completable_entities = newCompletableEntities;
          self.selectedCriteriaIdList = self.currentBadge.completable_entities.map(entity => entity.entity_id);
          self.criteria.loading = false;
          self.criteria.showCriteriaSearch = false;
        }).catch(err => {
          console.log(err);
          Application.messaging.addMessage({ type: 'error', duration: 6, text: 'There was an error adding your criteria' });
          self.criteria.loading = false;
          self.criteria.showCriteriaSearch = false;
        })
    },
    toggleCriteria: function (criteriaId, action) {
      self.currentBadge.completable_entities.forEach(item => {
        if (item.entity_id === criteriaId) {
          item.active = !item.active;
        }
      })
      Badges.update({ subresource: self.currentBadge._id }, { completable_entities: criteriaToCriteriaDTO(self.currentBadge.completable_entities) }).$promise
        .then(id => {
          const successMessage = `Your criteria has been successfully ${action}d`;
          Application.messaging.addMessage({ type: 'success', duration: 6, text: successMessage });
        })
    },
    clickHandler: function (criteriaId) {
      self.criteria.activeEditId = criteriaId;
      self.criteria.showEditMenu = true;
    },
    closeHandler: function () {
      self.criteria.activeEditId = '';
      self.criteria.showEditMenu = false;
    }
  }

  self.avatar = {
    image: '',
    active: false,
    loading: false,
    percent: null,
    image_name: '',
    modifiedLink: '',
    old: '',
    crop: function(link) {
      self.avatar.saveImage(link);
    },
    cancelCrop: function() {
      self.avatar.image = '';
      self.avatar.percent = null;
      self.avatar.loading = false;
      self.avatar.active = false;
      self.avatar.apply = false;
    },
    remove: function() {
      self.avatar.old = self.currentBadge.uploaded_image;
      self.avatar.saveImage('');
    },
    progress: function() {
      if (this.percent === null) {
        return 0 + '';
      }
      return this.percent - 100 + '%';
    },
    saveImage: async function(image) {
      self.currentBadge.uploaded_image = image;
      self.avatar.cancelCrop();
    }
  };

  $scope.$watch('badge.avatar.image', function(newVal, oldVal) {
    if (!newVal || newVal === oldVal) {
      return;
    }

    self.avatar.active = true;
  });

  self.currentBadge = {
    title: '',
    description: '',
    uploaded_image: '',
    completable_entities: [],
    active: false
  }

  self.init = function () {
    if (self.routeParams.id) {
      Badges.findOne({ subresource: self.routeParams.id }).$promise
        .then(badge => {
          self.currentBadge = badge;
          self.selectedCriteriaIdList = self.currentBadge.completable_entities.map(entity => entity.entity_id);
          Badges.getAwardedByBadge({ subsubsubresource: self.currentBadge._id }).$promise
            .then(users => {
              self.awardedUsers = users;
              self.loading = false;
            }).catch(err => {
              console.log(err);
              self.loading = false;
            })
        }).catch(err => {
          console.log(err);
          self.loading = false;
          self.noBadge = true;
        })
    } else {
      self.loading = false;
    }
  }

  self.toggleColor = function () {
    return self.currentBadge.active ? {} : {'background': '#F3370E'};
  }


  $scope.$watch('badge.currentBadge.title', (newVal, oldVal) => {
    if (self.loading) {
      return;
    }
    if (!self.currentBadge._id) {
      return
    }
    if (newVal === oldVal) {
      return;
    }
    self.updated.title = newVal;
  })

  $scope.$watch('badge.currentBadge.description', (newVal, oldVal) => {
    if (self.loading) {
      return;
    }
    if (!self.currentBadge._id) {
      return;
    }
    if (newVal === oldVal) {
      return;
    }
    self.updated.description = newVal;
  })

  $scope.$watch('badge.currentBadge.uploaded_image', (newVal, oldVal) => {
    if (self.loading) {
      return;
    }
    if (!self.currentBadge._id) {
      return;
    }
    if (newVal === oldVal) {
      return;
    }
    self.updated.uploaded_image = newVal;
  })

  $translate([
    'adminBadges.image.imageUploadError',
    'userEditor.image_saved'
  ]).then(function(translations){
    self.translations = translations;
    self.init();
  })
}]);